const WorksheetTypeBox = ({ type }) => {
  const typeInfo = {
    analysis: {
      name: "지문분석 워크북",
      backgroundColor: "rgba(45, 240, 52, 0.45)",
    },
    comprehensive: {
      name: "내용이해 워크북",
      backgroundColor: "rgba(255, 170, 52, 0.6)",
    },
    paragraph: {
      name: "모의고사 유형",
      backgroundColor: "rgba(67, 140, 251, 0.45)",
    },
    vocabulary: {
      name: "단어테스트",
      backgroundColor: "rgba(255, 86, 187, 0.45)",
    },
    sentence: {
      name: "문장테스트",
      backgroundColor: "rgba(255, 204, 0, 0.6)",
    },
    grammar: {
      name: "어법",
      backgroundColor: "rgba(156, 45, 240, 0.45)",
    },
    paper_assignment: {
      name: "지필과제",
      backgroundColor: "rgba(255, 152, 0, 0.5)",
    },
  };

  return (
    <div
      style={{
        backgroundColor: typeInfo[type]
          ? typeInfo[type].backgroundColor
          : "#fff",
        color: "#000",
        borderRadius: "5px",
        padding: "3px",
        width: "95px",
        fontSize: "13px",
        display: "inline-block",
        textAlign: "center",
      }}
    >
      {typeInfo[type] ? typeInfo[type].name : ""}
    </div>
  );
};

export default WorksheetTypeBox;
